// svc-marketplace puts the human-readable reason in one of two places
// depending on how the error was thrown (mjs-service errorHandler,
// modules/mjs-service/src/index.js):
//
//   HTTPError(code, 'a string')   -> {error: {message, statusCode, title}}
//   HTTPError(code, {message, …}) -> {message, …}
//   PlatformError                 -> {type, code, title, message, …}
//
// Reading only `data.message` silently drops every string-form HTTPError —
// that is how carriers ended up seeing "Request failed with status code 403"
// instead of "This appointment time may conflict with one of {Driver}'s
// scheduled trips." (svc-marketplace tripUtils.js assignDriver).

/**
 * Pulls the server-supplied message out of an axios error, whichever envelope
 * it arrived in.
 *
 * Returns ONLY what the server said — never axios's own "Request failed with
 * status code N". Callers own their fallback, because they disagree about what
 * it should be: the shared hooks want the axios message, modals prefer their
 * own copy ("Unable to assign driver").
 *
 * `data.message` is checked first so the flat envelopes keep winning exactly as
 * before; the nested lookup is a fallback, not a replacement.
 *
 * @param {Object} error - axios error
 * @returns {string|undefined} the server's message, or undefined if it sent none
 */
export function getApiErrorMessage(error) {
  const data = error?.response?.data
  return data?.message || data?.error?.message || undefined
}
